import React from "react";

import Radio from "@mui/material/Radio";

export default function CheckRadio({ color, ...moreProps }) {
  return <Radio {...moreProps} color={color ? color : "primary"} />;
}
